import { render, staticRenderFns } from "./Apropos.vue?vue&type=template&id=38bbe4b7&scoped=true"
import script from "./Apropos.vue?vue&type=script&lang=js"
export * from "./Apropos.vue?vue&type=script&lang=js"
import style0 from "./Apropos.vue?vue&type=style&index=0&id=38bbe4b7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bbe4b7",
  null
  
)

export default component.exports